import subscribers from "../components/views/subscribers/mixins/subscribers"

export default class SubscriberService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getFormFilterData(params) {
		return this.apiService.callGet('me/subscribers/form_filter_data', params)
	}

	getSubscriberTypeList(params) {
		return this.apiService.callGet('me/subscribers/subscriber_types', params)
	}

	deleteSubscribersDevicesCache(params) {
		return this.apiService.callPost('me/subscribers/delete_device_cache', params)
	}

	// AUTH
	login(user) {
		return this.apiService.callPost('login', user)
	}

	logout() {
		return this.apiService.callPost('logout')
	}

	// SUBSCRIBER
	getEntities(params) {
		return this.apiService.callGet('me/subscribers', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/subscribers/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/subscribers', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/subscribers/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/subscribers/' + id, params)
	}

	// SUBSCRIBER SERVICE INTERVALS
	getSubscriberServiceIntervals(id, params) {
		return this.apiService.callGet('me/subscribers/' + id + '/final_service', params)
	}

	// BILLER
	createBiller(subscriberId, params) {
		return this.apiService.callPost('me/subscribers/' + subscriberId + '/billers', params)
	}

	// SERVICES
	getSubscriberServices(subscriberId, params) {
		return this.apiService.callGet('me/subscribers/' + subscriberId + '/services', params)
	}

	updateSubscriberServices(subscriberId, params) {
		return this.apiService.callPost('me/subscribers/' + subscriberId + '/services', params)
	}

	getSubscriberDevicesAndPairingCodes(subscriberId) {
		return this.apiService.callGet('me/subscribers/' + subscriberId + '/devices_pairing_codes')
	}

	deleteSubscriberDevicesCache(subscriberId) {
		return this.apiService.callDelete('me/subscribers/' + subscriberId + '/delete_devices_cache')
	}


	resetSubscriberPassword(subscriberId, params){
		return this.apiService.callPost('me/subscribers/'+ subscriberId + '/reset_password', params);
	}

	// DASHBOARD
	getSubscriberDashboard(subscriberId, params) {
		return this.apiService.callGet('me/subscribers/' + subscriberId + '/dashboard', params)
	}
	updateSubscriberDashboard(subscriberId, params) {
		return this.apiService.callPut('me/subscribers/' + subscriberId + '/dashboard', params)
	}

	// RESTRICTED_CHANNELS
	getSubscriberProfileRestrictedChannels(subscriberId, params) {
		return this.apiService.callGet('me/subscribers/' + subscriberId + '/restricted_channels', params)
	}

	updateSubscriberProfileRestrictedChannels(subscriberId, params) {
		return this.apiService.callPut('me/subscribers/' + subscriberId + '/restricted_channels', params)
	}

	// SEARCH
	searchSubscribers(params) {
		return this.apiService.callGet('me/subscribers_search', params)
	}

}



// WEBPACK FOOTER //
// ./src/service/SubscriberService.js